/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const CloseTickIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 22 22", fill: "currentColor", width: size || '1em', height: size || '1em', ...props },
    React.createElement("path", { stroke: "currentColor", fill: "currentColor", d: "M9.996 9.29L.707 0 0 .707l9.29 9.29L0 19.285l.707.707 9.29-9.29 9.289 9.29.707-.707-9.29-9.29 9.29-9.289L19.286 0l-9.29 9.29z", transform: "translate(1 1)", strokeLinecap: "round", fillRule: "evenodd" })));
CloseTickIcon.displayName = 'CloseTickIcon';
export default CloseTickIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CloseTickIcon.js.map